"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CollapseItem = _interopRequireDefault(require("./CollapseItem.style"));
var _Collapse = require("../Collapse");
var _excluded = ["classPrefix", "children", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CollapseItem = function CollapseItem(_ref) {
  var classPrefix = _ref.classPrefix,
    children = _ref.children,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_CollapseItem["default"], _extends({
    className: "".concat(classPrefix, "Item ").concat(className)
  }, otherProps), children);
};
CollapseItem.propTypes = {
  /** The html class name */
  classPrefix: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
CollapseItem.defaultProps = {
  classPrefix: _Collapse.COLLAPSE_ROOT_CLASS_NAME,
  className: ''
};
CollapseItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CollapseItem",
  "props": {
    "classPrefix": {
      "defaultValue": {
        "value": "COLLAPSE_ROOT_CLASS_NAME",
        "computed": true
      },
      "description": "The html class name",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = CollapseItem;
exports["default"] = _default;